import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { ChunkErrorBoundary } from 'src/components/ChunkErrorBoundary';
import { SidebarProvider } from 'src/contexts/AppContext';
import * as serviceWorker from 'src/serviceWorker';

ReactDOM.render(
  <ChunkErrorBoundary>
    <HelmetProvider>
      <SidebarProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SidebarProvider>
    </HelmetProvider>
  </ChunkErrorBoundary>,
  document.getElementById('root')
);

serviceWorker.unregister();
